import Prop from './Prop';

export default Prop;
